module.exports = __webpack_public_path__ + "img/img3.906003c5.jpg";